// Minute Media (SendToNews) video player configuration.
// Whether the player renders (and the A/B split) is driven by remote config
// (APP_REMOTE_CONFIG.MINUTE_MEDIA_PLAYER -> appState.minuteMediaPlayerModel.shouldRender).
// The player key + script URL live here so they can be adjusted in code.
export const MINUTE_MEDIA_PLAYER_CONFIG = {
  playerKey: 'yw31ol5p',
  scriptBaseUrl: 'https://players.voltaxservices.io/players/365-scores/365_scores/code',
  direction: {
    ltr: 6,
    rtl: 1
  },
  sizes: {
    desktop: {
      width: 540,
      height: 288,
    },
    mobile: {
      width: 300,
      height: 160,
    },
  },
};
